import React, { useEffect, useState } from "react";
import "./cafe.scss";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import AutoComplete from "rsuite/AutoComplete";
import ReactPaginate from "react-paginate";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import { BsSearch } from "react-icons/bs";

function Cafe() {
  const [data, setData] = useState([]);
  const [autoComplete, setAutoComplete] = useState([]);
  const [search, setsearch] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState();
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [getSuccess, setGetSuccess] = useState(false);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  const [modalShow, setModalShow] = useState(false);
  const [idCafe, setIdCafe] = useState();

  const getData = async () => {
    const result = await axios.get("https://mobile.amospa.com/cafe");
    const name = result.data.data.map((value) => value.name);
    setAutoComplete(name);
    setData(result.data.data);
    setGetSuccess(true);
  };

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  useEffect(() => {
    getData();
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [deleteSuccess, itemOffset, itemsPerPage, getSuccess]);

  //Handle search
  const keys = ["name"];
  const handleSearch = () => {
    return search
      ? data.filter((item) => keys.some((key) => item[key].includes(search)))
      : false;
  };

  const cafe = handleSearch();
  const dataTable = cafe ? cafe : currentItems;

  //Handle Delete
  const deleteCafe = async (id) => {
    setIdCafe(id);
    setModalShow(true);
  };

  //Handle Next
  const handleNext = async () => {
    const result = await axios.delete(
      `https://mobile.amospa.com/cafe/${idCafe}`
    );
    setDeleteSuccess(result);
    setModalShow(false);
    window.location.reload();
  };

  return (
    <div className="wrapper-cafe">
      <div className="cafe">
        <div className="header-cafe py-4">
          <span className="d-flex align-items-center">
            <h3 className="mx-2 text-white">List Cafe</h3>
            <p>
              <select onChange={(e) => setitemsPerPage(e.target.value)}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </p>
          </span>
          <span className="d-flex">
            <Link to={"/homepage/cafe/add-cafe"}>
              <button
                className="btn rounded-3 me-2 fw-bold"
                style={{ background: "#FFD700" }}
              >
                ADD CAFE
              </button>
            </Link>
            <span className="d-flex align-items-center list-search bg-light rounded-3 ps-1 me-2">
              <BsSearch color="black" fontSize="20px" />
              <AutoComplete
                placeholder="Search . . ."
                id="rs-input"
                onChange={(e) => setsearch(e)}
                data={autoComplete}
              />
            </span>
          </span>
        </div>
        <div className="table-users-mobile">
          <Table striped bordered hover className="m-0">
            <thead>
              <tr>
                <th>No</th>
                <th>Name</th>
                <th>Picture</th>
                <th>PDF</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {dataTable.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item ? item.name : ""}</td>

                  <td>
                    <img src={item ? item.picture : ""} alt="" />
                  </td>
                  <td>
                    <a href={item.pdf}>
                      <button
                        className="btn-staffid ms-2 bg-warning text-dark px-2 py-1"
                        style={{ borderRadius: "10px" }}
                      >
                        Download PDF
                      </button>
                    </a>
                  </td>
                  <td className="d-flex">
                    <Link to={`/homepage/cafe/edit-cafe/${item.id}`}>
                      <button
                        className="btn-staffid ms-2 bg-warning text-dark py-1 px-3"
                        style={{ borderRadius: "10px" }}
                      >
                        Edit
                      </button>
                    </Link>
                    <button
                      className="btn-staffid ms-2 bg-danger px-2 py-1"
                      onClick={() => deleteCafe(item.id)}
                      style={{ borderRadius: "10px" }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className="footer-role py-3">
          <p className="ms-2">
            Showing {currentItems.length} to {data.length} Entries
          </p>
          <div>
            <ReactPaginate
              breakLabel="..."
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              pageCount={pageCount}
              previousLabel="< previous"
              renderOnZeroPageCount={null}
              containerClassName="pagination"
              pageLinkClassName="page-num"
              previousLinkClassName="page-num"
              nextLinkClassName="page-num"
              activeLinkClassName="active"
            />
          </div>
        </div>
      </div>
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Delete Cafe ?"
        nextButton={handleNext}
      />
    </div>
  );
}

export default Cafe;
